/* RESPONSIBLE TEAM: team-phone */

import type {
  FinVoiceNumberConfigurationHandoverConfiguration,
  ScheduledConfigurationKey,
} from 'embercom/models/fin-voice/number-configuration';
import { FIN_VOICE_NO_CONFIG_ERROR, FIN_VOICE_NO_CONFIG_ERROR_WITH_KEY } from './constants';
import { isValidEmail } from 'embercom/lib/email';
import isValidUrl from 'embercom/lib/url-validator';

export function handoverConfigErrorForConfigType(
  handoverConfig: FinVoiceNumberConfigurationHandoverConfiguration | undefined,
  configType: ScheduledConfigurationKey,
): { error: string; label?: string } | undefined {
  let isDefault = configType === 'default';

  let label =
    configType === 'in'
      ? 'operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.in-label'
      : 'operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.nin-label';

  if (!handoverConfig || !Object.keys(handoverConfig).length) {
    return {
      error: isDefault ? FIN_VOICE_NO_CONFIG_ERROR : FIN_VOICE_NO_CONFIG_ERROR_WITH_KEY,
      label: isDefault ? undefined : label,
    };
  }

  let handoverConfigForType = handoverConfig[configType];

  if (!handoverConfigForType?.type) {
    return {
      error: `operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.error.no-type${isDefault ? '' : '-with-key'}`,
      label,
    };
  }

  if (handoverConfigForType.type === 'handover-to-human') {
    if (!handoverConfigForType.config?.assigneeId) {
      return {
        error: `operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.error.no-assignee${isDefault ? '' : '-with-key'}`,
        label,
      };
    }
  }

  if (handoverConfigForType.type === 'deflect-escalation') {
    if (
      handoverConfigForType.config.offerChat &&
      isValidUrl(handoverConfigForType.config.chatUrl) === null
    ) {
      return {
        error: `operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.error.invalid-chat-url${isDefault ? '' : '-with-key'}`,
        label,
      };
    }

    if (
      handoverConfigForType.config.offerEmail &&
      !isValidEmail(handoverConfigForType.config.emailAddress)
    ) {
      return {
        error: `operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.error.invalid-email${isDefault ? '' : '-with-key'}`,
        label,
      };
    }
  }

  return undefined;
}
